/**
 * Tiny JSON persistence helpers.
 * Prefer these over a global store when the only need is surviving refresh.
 */

export function readJson(storage, key, fallback) {
  if (typeof window === 'undefined') return fallback;
  try {
    const raw = storage.getItem(key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writeJson(storage, key, value) {
  if (typeof window === 'undefined') return;
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch {
    // Quota / private mode — ignore; UI still works in-memory.
  }
}

export function removeKey(storage, key) {
  if (typeof window === 'undefined') return;
  try {
    storage.removeItem(key);
  } catch {
    // ignore
  }
}

/** React state that rehydrates from storage and writes back on change. */
export function createPersistedInitializer(storage, key, fallback) {
  return () => readJson(storage, key, fallback);
}
